import { OptionSelect_V2 } from "../../services/fomartUnit";
import axiosClient, { ResponseSuccess, ResponseSuccessTotal } from "../axiosClient";
import { listUnitPer, permissionGroupsByUnit } from "../groupPermission/groupPermissionApi";

export interface DataTypeObject {
  id: undefined | number,
  access: boolean,
  add: boolean,
  edit: boolean,
  delete: boolean,
  upload: boolean,
  download: boolean,
  share: boolean

}

export interface DataTypeAdmin {
  key: number
  id: number
  ho_ten: string
  ten_tai_khoan: string
  phong_ban: string
  khoi_nghiep_vu: string
  don_vi: string
  vung_mien: string
  toan_quoc: string
  nhom_quyen: string
  listUnitPer: listUnitPer[]
}

export interface DataTypeAdminV2 {
  key: number
  id: number
  ho_ten: string
  cus_email: string
  phong_ban: string
  khoi_nghiep_vu: string
  don_vi: string
  vung_mien: string
  toan_quoc?: string
}


export interface IDecentralization {
  id: number
  key?:number
  parentId?: number
  name: string
  access: boolean
  add: boolean
  edit: boolean
  delete: boolean
  upload: boolean
  download: boolean
  approve:boolean
  children: ChildrenDecentralization[]
}

export interface ChildrenDecentralization {
  id: number
   key?:number
  parentId?: number
  name: string
  access: boolean
  add: boolean
  edit: boolean
  delete: boolean
  upload: boolean
  download: boolean
  approve:boolean
  children?: ChildrenDecentralization[]
}

export interface FlattenedData {
  id: number;
  access: boolean;
  add: boolean;
  edit: boolean;
  delete: boolean;
  upload: boolean;
  download: boolean;
  approve:boolean
  // share: boolean;
}

export interface IAdmin {
  id: number
  username: string
  fullname: string
  businessUnit: string
  unit: string
  region: string
  department: string
  nationwide: string
  groupPermission: string
  email?:string
}





export const getListmenu = async () => {
  const path = "groupPermission/listmenu"
  const result: ResponseSuccess<IDecentralization[]> = await axiosClient.get(
    path, {}
  );
  return result;
};




export const getListAdmin = async (limit?: number, pageNumber?: number, unitId?: number, businessUnitId?: number, search?: string
) => {
  const path = "auth/allAdmin"
  const params = {
    limit, pageNumber, search, unitId, businessUnitId
  }
  const result: ResponseSuccessTotal<IAdmin[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};
